import {useSearchParams} from "react-router";
import {useRef, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import AlarmTimelineService from "../../../services/reports/alarm-timeline-service.js";
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";

export default function AlarmTimeline() {
    const [searchParams] = useSearchParams();
    const [isPrinting, setIsPrinting] = useState(false);
    const [headerSelected, setHeaderSelected] = useState(-1);
    const printComponentRef = useRef(null);
    const alarmId = searchParams.get("id");
    const title = "Linha do tempo do alarme";

    const { data: reportAlarmTimeline, isLoading } = useQuery({
        queryKey: ['alarm-timeline', alarmId],
        queryFn: () => AlarmTimelineService.getAlarmTimeline(alarmId),
        enabled: !!alarmId,
    });

    const hasData = !!reportAlarmTimeline?.id;

    return (
        <Template isLoading={isLoading || isPrinting}>
            <Template.Header>
                <Template.Title browserTitle={title}>{title}</Template.Title>
                <HeaderButtons
                    printable={true}
                    headerChange={true}
                    printComponentRef={printComponentRef}
                    reportData={reportAlarmTimeline}
                    data={hasData}
                    headerSelected={headerSelected}
                    setHeaderSelected={setHeaderSelected}
                />
            </Template.Header>
            <Template.Body>
                <Card>
                    <Card.Body>
                        <Content
                            reportData={reportAlarmTimeline}
                            data={hasData}
                            entity={headerSelected}
                            title={title}
                            printComponentRef={printComponentRef}
                            setIsPrinting={setIsPrinting}
                        />
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}